import {
  Modal,
  ModalOverlay,
  ModalContent,
  HStack,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Button,
  ModalFooter,
  Box,
  Text,
  useToast,
} from "@chakra-ui/react";
import { Formik, Field } from "formik";

import * as yup from "yup";
import React from "react";

const Form = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const nameInput = React.useRef(null);
  const phoneNumberInput = React.useRef(null);
  const toast = useToast();
  let schema = yup.object().shape({
    name: yup
      .string()
      .required("يجب ادخال الاسم")
      .min(3, "يجب ادخال الاسم بشكل صحيح ولا يقل عن 3 احرف"),

    phoneNumber: yup
      .string()
      .required("يجب ادخال رقم الجوال بشكل صحيح ولا يقل عن 10 ارقام")
      .matches(
        /^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/,
        "يجب ادخال رقم الجوال بشكل صحيح ولا يقل عن 10 ارقام"
      ),
  });

  const sendFormClicked = async (values: {
    name: string;
    phoneNumber: string;
  }) => {
    try {
      const response = await fetch("/api/tickets/create", {
        method: "POST",
        body: JSON.stringify({
          createdBy: values.name,
          phoneNumber: values.phoneNumber,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const responseData = await response.json();
      if (responseData.status !== 201) {
        throw new Error(responseData.message);
      }
      toast({
        title: "تم ارسال الطلب بنجاح",
        description: "سيتم التواصل معك قريبا",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      onClose();
    } catch (error) {
      toast({
        title: "حدث خطأ",
        description: "حاول مرة اخرى",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <HStack spacing="25px">
          <Box>
            <ModalCloseButton />
          </Box>
          <Box>
            <ModalHeader>
              <Text fontSize="2xl">اطلب الآن</Text>
            </ModalHeader>
          </Box>
        </HStack>
        <ModalBody pb={6}>
          <Formik
            initialValues={{ name: "", phoneNumber: "" }}
            validationSchema={schema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              sendFormClicked(values);
              setSubmitting(false);
            }}
          >
            {/* formik with typescript */}
            {({
              handleSubmit,
              errors,
              touched,
            }: {
              handleSubmit: any;
              errors: any;
              touched: any;
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack spacing={4}>
                  <Field name="name">
                    {({ field, form }: { field: any; form: any }) => (
                      <FormControl
                        isInvalid={
                          form.errors.name && form.touched.name ? true : false
                        }
                      >
                        <FormLabel htmlFor="name">الاسم</FormLabel>
                        <Input
                          {...field}
                          id="name"
                          placeholder="الاسم"
                          ref={nameInput}
                        />
                        <FormLabel color="red.500">
                          {form.errors.name && form.touched.name
                            ? form.errors.name
                            : null}
                        </FormLabel>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="phoneNumber">
                    {({ field, form }: { field: any; form: any }) => (
                      <FormControl
                        isInvalid={
                          form.errors.phoneNumber && form.touched.phoneNumber
                            ? true
                            : false
                        }
                      >
                        <FormLabel htmlFor="phoneNumber">رقم الجوال</FormLabel>
                        <Input
                          {...field}
                          id="phoneNumber"
                          placeholder="رقم الجوال"
                          ref={phoneNumberInput}
                        />
                        <FormLabel color="red.500">
                          {form.errors.phoneNumber && form.touched.phoneNumber
                            ? form.errors.phoneNumber
                            : null}
                        </FormLabel>
                      </FormControl>
                    )}
                  </Field>
                  <Button
                    colorScheme="teal"
                    type="submit"
                    onClick={handleSubmit}
                  >
                    اطلب الان
                  </Button>
                </Stack>
              </form>
            )}
          </Formik>
        </ModalBody>

        <ModalFooter>
          <Stack spacing={3} direction="row" align="center">
            <Button onClick={onClose}>اغلاق</Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default Form;
